module.exports = __webpack_public_path__ + "img/ent_object.a2b4378a.png";